export const scrollView = async (id) => {
    document.getElementById(id).scrollIntoView({behavior: 'smooth'})
} 